import {useApi} from "../Api";
import {PagedResponse} from "../types/pagination";
import {buildQueryParams} from "../../utils";
import {
    FormSearchGreenDiscountModel,
    GreenDiscountEntityRequest,
    GreenDiscountEntityResponse
} from "../types/greenDiscount";

export const useGreenDiscountRepository = () => {
    const {GET, POST, PUT, DELETE} = useApi();

    const PATH = "/pricing/green-discount-rate";

    function getGreenDiscount(id: number): Promise<GreenDiscountEntityResponse> {
        return GET(`${PATH}?id=${id}`);
    }

    function getGreenDiscountList(): Promise<GreenDiscountEntityResponse[]> {
        return GET(`${PATH}/list`);
    }

    function getGreenDiscountPaged(filters: FormSearchGreenDiscountModel): Promise<PagedResponse<GreenDiscountEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter${queryParams ? query + queryParams : ""}`);
    }

    function putGreenDiscount(greenDiscount: GreenDiscountEntityResponse): Promise<GreenDiscountEntityResponse> {
        return PUT(`${PATH}`, greenDiscount);
    }

    function postGreenDiscount(greenDiscount: GreenDiscountEntityRequest): Promise<GreenDiscountEntityResponse> {
        return POST(`${PATH}`, greenDiscount);
    }

    function deleteGreenDiscount(id: number): Promise<string> {
        return DELETE(`${PATH}?id=${id}`);
    }

    function terminateGreenDiscount(id: number): Promise<GreenDiscountEntityResponse> {
        return GET(`${PATH}/terminate?id=${id}`);
    }

    function getGreenDiscountInUse({id}: { id: number }): Promise<boolean> {
        return GET(`${PATH}/in-use?id=${id}`);
    }

    return {
        getGreenDiscountPaged,
        putGreenDiscount,
        postGreenDiscount,
        deleteGreenDiscount,
        getGreenDiscountInUse,
        terminateGreenDiscount
    };
};